export default "__VITE_ASSET__qnACoGr5__"